import { render } from "./addClient.vue?vue&type=template&id=362d195e&scoped=true"
import script from "./addClient.vue?vue&type=script&lang=js"
export * from "./addClient.vue?vue&type=script&lang=js"

import "./addClient.vue?vue&type=style&index=0&id=362d195e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362d195e"]])

export default __exports__